<template>
  <!-- 목표 달성시 style="display: block;" 추가 -->
  <div class="abo-dimmed" style="display: none;">
    <div class="dimmed-text">
      {{attainmentmonth}}월 목표 달성에 <br>성공하셨습니다!
    </div>
  </div>
</template>
<script>
export default {
  props: ['attainmentmonth']
}
</script>

<style scoped>
@import '../assest/css/abo.css';
</style>



// WEBPACK FOOTER //
// src/views/sales/dashboard/component/layerAttainmentMessage.vue